import React, { useState } from 'react';



import client01 from "../assets/clients-img/aarti2.jpg";
import client02 from "../assets/clients-img/afrisian01.jpg";
import client03 from "../assets/clients-img/afrisian02.jpg";
import client04 from "../assets/clients-img/grasim.jpeg";
import client05 from "../assets/clients-img/grasim-01.jpg";
// import client06 from "../assets/clients-img/i-2.jpg";
// import client07 from "../assets/clients-img/i-3.jpeg";
// import client08 from "../assets/clients-img/i-4.webp";
// import client09 from "../assets/clients-img/i5.jpeg";
import client10 from "../assets/clients-img/i-6.jpg";
import client11 from "../assets/clients-img/i-7.png";
// import client12 from "../assets/clients-img/i-9.png";
// import client13 from "../assets/clients-img/i-10.jpeg";
//import client14 from "../assets/clients-img/i-11.jpeg";
import client15 from "../assets/clients-img/i-12.jpeg";
//import client16 from "../assets/clients-img/i-13.webp";
//import client17 from "../assets/clients-img/i-14.jpeg";
import client18 from "../assets/clients-img/mfl.jpeg";
import client19 from "../assets/clients-img/navbharat.jpg";
import client20 from "../assets/clients-img/paratex.jpg";

import Navbar from './Navbar';
import Footer from './Footer';

const OurClients = () => {
    const [selectedImage, setSelectedImage] = useState(null); // State to hold the currently selected image

    const images = [
        client01, client02, client03, client04, client05,  client10, client11, client15,  client18, client19, client20

        // Add the rest of the images here...
    ];

    const handleImageClick = (image) => {
        setSelectedImage(image); // Set the selected image
    };

    const handleClose = () => {
        setSelectedImage(null); // Clear the selected image
    };

    return (
        <div>

            {/* <Navbar /> */}
            <section id="work" className="py-12 bg-gray-100 mt-6">
                <div className="container mx-auto px-4">
                    <h1 className="text-4xl font-bold text-center mb-4">
                        <span className="text-purple-800">Our Clientele</span>
                    </h1>
                    <p className="text-center font-semibold text-gray-600 mb-8">
                        <span>We provide high standard work for your Company solutions</span>
                    </p>

                    <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                        {images.map((image, index) => (
                            <div
                                key={index}
                                className="overflow-hidden rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
                                onClick={() => handleImageClick(image)} // Set the image on click
                            >
                                <img
                                    src={image}
                                    alt={`Gallery Image ${index + 1}`}
                                    className="w-full h-64 object-cover hover:scale-105 transition-transform duration-300 cursor-pointer"
                                />
                            </div>
                        ))}
                    </div>
                </div>

                {/* Modal to show selected image */}
                {selectedImage && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 " >
                        <div className="relative">
                            <img
                                src={selectedImage}
                                alt="Selected"
                                className="max-w-full max-h-screen rounded-lg"
                            />
                            <button
                                onClick={handleClose}
                                className="absolute top-2 right-2 text-white bg-red-600 hover:bg-red-700 rounded-full p-2"
                            >
                                ✖
                            </button>
                        </div>
                    </div>
                )}
            </section>

            {/* <Footer /> */}
        </div>
    );
};

export default OurClients;
